// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';
import theme from './theme';
import HomePage from './pages/HomePage';
import TeamPage from './pages/TeamPage';
import SchedulePage from './pages/SchedulePage';
import FansPage from './pages/FansPage';
import MerchandisePage from './pages/MerchandisePage';
import ForumPage from './pages/ForumPage';
import LoginPage from './pages/LoginPage';
import AdminPanel from './pages/AdminPanel';
import SignupPage from './pages/Signup';
import SignInPage from './pages/Signin';
import FootballPortal from './pages/FootballPortal';
import SupporterPortal from './pages/SupporterPortal';
import AdminWorkspace from './pages/AdminWorkspace';
import PartnersPage from './pages/PartnersPage';
import { SponsorProvider } from './components/sponsors/SponsorBranding';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const App = () => {
  return (
    <GoogleOAuthProvider clientId="446919455339-vvk8rrgldf3kj06vi5n8oamtl649ms91.apps.googleusercontent.com">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <SponsorProvider><Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/fans" element={<FansPage />} />
            <Route path="/merchandise" element={<MerchandisePage />} />
            <Route path="/forum" element={<ForumPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/football" element={<FootballPortal />} />
            <Route path="/supporters" element={<SupporterPortal />} />
            <Route path="/admin" element={<ProtectedRoute admin><AdminPanel /></ProtectedRoute>} />
            <Route path="/admin/platform" element={<ProtectedRoute admin><AdminWorkspace /></ProtectedRoute>} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/partners" element={<PartnersPage />} />
          </Routes></SponsorProvider>
        </Router>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
